import DataLayer from "@client/classes/data-layer/data-layer";
import BBBWidget from "@client/components/bbb";
import TrustPilotWidget from "@client/components/trust-pilot";
import {
	DEFAULT_JOURNEY,
	EVENT_CTA_CLICKED,
	setUserInteractionDataAttribute,
	TRUST_PILOT_BUSINESS_UNIT_ID,
} from "@shared/constants";
import { LinkButton } from "@ui/js/components/buttons/link-button";
import clsx from "clsx";

interface Props {
	hasCTA?: boolean;
	page: string;
	totalMonths?: number;
}

export default function DebtCalculatorCTACard({
	page,
	hasCTA,
	totalMonths = 24,
}: Props) {
	const handleOnClickEvent = () =>
		DataLayer.events.trigger(EVENT_CTA_CLICKED, {
			page: page,
		});

	return (
		<div
			className={clsx(
				"grid gap-4 bg-action-background px-4 py-8 text-center w-full lg:mb-8",
				{
					"mt-8": !hasCTA,
				},
			)}
		>
			<div>
				<div className="text-2xl font-semibold">
					{totalMonths > 24
						? "Pay off your debt in as little as 24 months."
						: "You may be eligible for relief up to 40%"}
				</div>
				<div className="mt-2">
					Let us help you get out of debt faster than your current path.
				</div>
			</div>
			<div className="mt-4">
				{/* Using a LinkButton here to link to the form because this page cannot have any client components */}
				<LinkButton
					{...setUserInteractionDataAttribute(
						`debt-calculator_cta_link_button__${page}`,
					)}
					text="Get Started"
					href={`/${DEFAULT_JOURNEY}`}
					onClick={handleOnClickEvent}
				/>
			</div>
			<div className="text-xs">
				Checking your options is free <br /> and won't affect your credit score.
			</div>
			{TRUST_PILOT_BUSINESS_UNIT_ID && (
				<TrustPilotWidget widgetType="MicroStar" />
			)}
			<BBBWidget className="h-7" />
		</div>
	);
}
